<template>
  <el-dialog :title="isEdit ? '编辑异常记录' : '新增异常记录'" :visible.sync="visible" width="700px" @closed="resetForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="异常标题" prop="abnormalTitle">
        <el-input v-model="form.abnormalTitle" placeholder="请输入异常标题"/>
      </el-form-item>
      <el-form-item label="发生日期" prop="statDate">
        <el-date-picker v-model="form.statDate" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期" style="width:100%"/>
      </el-form-item>
      <el-form-item label="产线编码" prop="lineCode">
        <el-input v-model="form.lineCode" placeholder="请输入产线编码"/>
      </el-form-item>
      <el-form-item label="工单号">
        <el-input v-model="form.workOrderNo" placeholder="请输入工单号"/>
      </el-form-item>
      <el-form-item label="异常类型" prop="abnormalType">
        <el-select v-model="form.abnormalType" placeholder="请选择异常类型" style="width:100%">
          <el-option label="设备故障" :value="1"/>
          <el-option label="物料异常" :value="2"/>
          <el-option label="质量批量不良" :value="3"/>
          <el-option label="工装夹具损坏" :value="4"/>
          <el-option label="人员短缺" :value="5"/>
          <el-option label="安全隐患" :value="6"/>
          <el-option label="能源" :value="7"/>
          <el-option label="工艺图纸" :value="8"/>
          <el-option label="设计变更" :value="9"/>
          <el-option label="其他" :value="10"/>
        </el-select>
      </el-form-item>
      <el-form-item label="异常等级" prop="abnormalLevel">
        <el-select v-model="form.abnormalLevel" placeholder="请选择等级" style="width:100%">
          <el-option label="一般" :value="1"/>
          <el-option label="重大停机" :value="2"/>
          <el-option label="紧急停线" :value="3"/>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择开始时间" style="width:100%"/>
      </el-form-item>
      <el-form-item label="上报人" prop="reportEmpName">
        <el-input v-model="form.reportEmpName" placeholder="请输入上报人"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"/>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "ProdAbnormalEdit",
    data() {
      return {
        visible: false,
        loading: false,
        isEdit: false,
        form: {
          abnormalTitle: "",
          statDate: "",
          lineCode: "",
          workOrderNo: "",
          abnormalType: null,
          abnormalLevel: null,
          startTime: "",
          reportEmpName: "",
          remark: "",
        },
        rules: {
          abnormalTitle: [{ required: true, message: "请输入异常标题", trigger: "blur" }],
          statDate: [{ required: true, message: "请选择发生日期", trigger: "change" }],
          abnormalType: [{ required: true, message: "请选择异常类型", trigger: "change" }],
          lineCode: [{ required: true, message: "请输入产线编码", trigger: "blur" }],
        },
      };
    },
    methods: {
      open(row) {
        this.visible = true;
        if (row && row.id) {
          this.isEdit = true;
          this.form = { ...row };
        } else {
          this.isEdit = false;
          this.resetForm();
        }
      },
      resetForm() {
        this.form = {
          abnormalTitle: "",
          statDate: "",
          lineCode: "",
          workOrderNo: "",
          abnormalType: null,
          abnormalLevel: null,
          startTime: "",
          reportEmpName: "",
          remark: "",
        };
        this.isEdit = false;
        this.$refs.form && this.$refs.form.resetFields();
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (!valid) return;
          this.loading = true;
          const method = this.isEdit ? "put" : "post";
          this.$http[method]("basic", "prodAbnormal", this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success(this.isEdit ? "编辑成功" : "新增成功");
                this.visible = false;
                this.$emit("save-success");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        });
      },
    },
  };
</script>
